import { isRollingPatternDisabledConfig, isRollingPatternReport, rollingScheduleGenerator } from '@iotv/datamodel-core';
import { getSchedulesBetweenUTCDates, isIoTVEntitySequentialProgrammeDef } from '@iotv/lfc-devices';
import { stateToPeriodOperatingState } from './extractedStateSnapshots';
/* ref https://developers.google.com/chart/interactive/docs/gallery/timeline */
const debug = process.env.REACT_APP_DEBUG && false;
export const getPeriodStates = (action) => {
    let update = { slicedStore: null, periodStates: null };
    const { recentStateHistory, fromDateValue, toDateValue } = action;
    if (recentStateHistory && fromDateValue && toDateValue) {
        const fromDate = fromDateValue.toDate();
        const toDate = toDateValue.toDate();
        const slicedStore = recentStateHistory.sliceByTimestamp([fromDate.valueOf(), toDate.valueOf()]);
        update.slicedStore = slicedStore;
        const extractedState = slicedStore.getStateSnapshotArray();
        if (extractedState.length > 0) {
            const periodStates = stateToPeriodOperatingState({ stateSnapshots: extractedState });
            if (periodStates.length > 0) {
                debug && console.log('updating periodStates', periodStates);
                update.periodStates = periodStates;
            }
        }
        else {
            debug && console.log('periodStates null');
            update.periodStates = null;
        }
    }
    debug && console.log(`GetPeriodStates got`, { action, update });
    return update;
};
const isGetFutureSequentialSchedulesInput = (x) => {
    const c = x;
    return !!c && c.sequentialSchedules instanceof Array && c.sequentialSchedules.every(isIoTVEntitySequentialProgrammeDef);
};
const isGetFuturRollingSchedulesInput = (x) => {
    const c = x;
    return !!c && c.rollingPatternReport && isRollingPatternReport(c.rollingPatternReport);
};
export const getFutureSchedules = (action) => {
    debug && console.log(`getFutureSchedules got`, action);
    const update = { sortedReportedSchedules: null };
    if (isGetFutureSequentialSchedulesInput(action)) {
        const { sequentialSchedules: currentSequentialSchedules, fromDateValue, toDateValue } = action;
        if (fromDateValue && toDateValue) {
            const fromDate = fromDateValue.toDate();
            const toDate = toDateValue.toDate();
            const baseDate = new Date();
            if (currentSequentialSchedules) {
                const sortedReportedSchedules = getSchedulesBetweenUTCDates({
                    dateRange: [fromDate, toDate],
                    schedules: currentSequentialSchedules,
                });
                update.sortedReportedSchedules = sortedReportedSchedules.filter((schedule) => {
                    const { enabled, dateRange } = schedule;
                    const endDate = dateRange.at(1);
                    return !!enabled && endDate && endDate > baseDate;
                });
            }
        }
        debug && console.log(`getFutureSchedules got`, { action, update });
    }
    else if (isGetFuturRollingSchedulesInput(action)) {
        const { rollingPatternReport, fromDateValue, toDateValue } = action;
        if (fromDateValue && toDateValue) {
            const fromDate = fromDateValue.toDate();
            const toDate = toDateValue.toDate();
            const baseDate = new Date();
            if (rollingPatternReport) {
                const generator = rollingScheduleGenerator({ startDate: fromDate, endDate: toDate, rollingPatternConfig: rollingPatternReport });
                const enabled = !isRollingPatternDisabledConfig(rollingPatternReport);
                const sortedReportedSchedules = Array.from(generator).map((dr) => {
                    const enabledDateRange = { dateRange: dr, enabled };
                    return enabledDateRange;
                });
                update.sortedReportedSchedules = sortedReportedSchedules.filter((schedule) => {
                    const { enabled, dateRange } = schedule;
                    const endDate = dateRange.at(1);
                    return !!enabled && endDate && endDate > baseDate;
                });
            }
        }
    }
    return update;
};
